module.exports = __webpack_public_path__ + "static/media/sol.f9d41810.jpg";